export const LOAD_STATUS_LABELS = {
  assigned: 'Assigned',
  en_route_pickup: 'En Route to Pickup',
  at_shipper: 'Arrived at Pickup',
  picked_up: 'Picked Up',
  in_transit: 'In Transit',
  at_receiver: 'Arrived at Delivery',
  delivered: 'Delivered',
  cancelled: 'Canceled',
  rejected: 'Rejected',
  recovered: 'Recovered',
};
export const LOAD_STATUSES = Object.keys(LOAD_STATUS_LABELS);
export const STATUSES_REQUIRE_REASON = ['cancelled', 'rejected', 'recovered'];
export const statusLabel = (s) => LOAD_STATUS_LABELS[s] || (s || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// One palette for every surface (loads list, dispatcher board, driver app, imports).
export const LOAD_STATUS_COLORS = {
  assigned: 'bg-blue-100 text-blue-700',
  en_route_pickup: 'bg-sky-100 text-sky-700',
  at_shipper: 'bg-amber-100 text-amber-700',
  picked_up: 'bg-teal-100 text-teal-700',
  in_transit: 'bg-green-100 text-green-700',
  at_receiver: 'bg-purple-100 text-purple-700',
  delivered: 'bg-slate-100 text-slate-700',
  cancelled: 'bg-red-100 text-red-700',
  rejected: 'bg-rose-100 text-rose-800',
  recovered: 'bg-orange-100 text-orange-800',
};
export const statusColor = (s) => LOAD_STATUS_COLORS[s] || 'bg-slate-100 text-slate-700';

// Driver's forward-only workflow. Delivered is reached through "Complete Trip" (POD gate).
export const DRIVER_FLOW = ['assigned', 'en_route_pickup', 'at_shipper', 'picked_up', 'in_transit', 'at_receiver', 'delivered'];
// Statuses the driver app treats as "trip in progress" (shows the active-load card).
export const DRIVER_IN_PROGRESS = ['en_route_pickup', 'at_shipper', 'picked_up', 'in_transit', 'at_receiver'];
// Exceptions — dispatch/admin only, always need a reason.
export const EXCEPTION_STATUSES = STATUSES_REQUIRE_REASON;

export const MATCH_STATUS_LABELS = { matched: 'Matched', needs_confirmation: 'Needs Confirmation', unlinked: 'Unlinked' };
export const MATCH_TYPE_LABELS = { exact: 'Exact', initial_last: 'Initial + Last Name', suggested: 'Suggested', manual: 'Manual' };
